module.exports = __webpack_public_path__ + "img/mcc_white.25708359.png";